import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="blueprint-grid bg-ink px-3 py-4 sm:px-6" data-id="element-180" data-mp="3kqw54mwtl6h6">
      <div className="mx-auto max-w-2xl" data-id="element-181" data-mp="3fyvxs9ef7bak">
        <h2 className="text-center font-display text-[1.45rem] font-extrabold uppercase leading-none text-white sm:text-[2rem]" data-id="element-182" data-mp="3fxuni758astw">
          WHAT CONSTRUCTION PROFESSIONALS <span className="text-hazard" data-id="element-183" data-mp="36z95cd3o5ftn">ARE SAYING</span>
        </h2>
        <div className="mt-2 space-y-2" data-id="element-184" data-mp="31zwab52n92fz">
          {testimonials.map(t => <figure key={t.name} className="rounded-md border border-line border-l-4 border-l-hazard bg-graphite px-2.5 py-2" data-id="element-185" data-mp="321z6k6ue3rt5">
              <div className="flex gap-0.5 text-hazard" role="img" aria-label="5 out of 5 stars" data-id="element-186" data-mp="2s1yp6qg2zlrl">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-3.5 w-3.5 fill-current" aria-hidden="true" data-id="element-187" data-mp="v8nar7dvcfh1" data-mpi={i} />)}
              </div>
              <p className="mt-1 font-display text-[0.92rem] font-bold leading-tight text-white sm:text-[1.08rem]" data-id="element-188" data-mp="h67ya15u5i8s">
                “{t.headline}”
              </p>
              <blockquote className="mt-0.5 text-[0.78rem] leading-[1.4] text-steel sm:text-[0.9rem]" data-id="element-189" data-mp="m6cia15ycv3r">“{t.quote}”</blockquote>
              <figcaption className="mt-1.5 text-[0.7rem] leading-tight sm:text-[0.8rem]" data-id="element-190" data-mp="c6vejpa9graf">
                <span className="font-bold text-hazard" data-id="element-191" data-mp="c8ojn05873gb">— {t.role}</span>
                <span className="text-steel" data-id="element-192" data-mp="zx7thk3xboai">
                  {' '}
                  · {t.name} · {t.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}